import { createRoute } from '@tanstack/react-router';

import { privacyPageLoadable } from 'pages/privacy-page';

import { rootRoute } from '../root';

export const PrivacyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/privacy',
  component: privacyPageLoadable,
});
